import { WorkflowApi } from 'axiosApi/apis/workflow-api';
import { setApiKeyToObject } from 'axiosApi/common';
import { AxiosResponse } from 'axios';

export interface StateMappingDTO {
  fromStateId: number;
  toStateId: number;
}

export class WorkflowApiWrapper {
  private workflowApi: WorkflowApi;

  constructor(workflowApi: WorkflowApi) {
    this.workflowApi = workflowApi;
  }

  private async buildHeaders(): Promise<Record<string, string>> {
    const configuration = (this.workflowApi as any).configuration;
    const headers: Record<string, string> = {};
    await setApiKeyToObject(headers, 'Userentity', configuration);
    await setApiKeyToObject(headers, 'Referer', configuration);
    await setApiKeyToObject(headers, 'Authorization', configuration);
    return headers;
  }

  /**
   * Returns a dictionary of stateId → entity count for all states in the workflow.
   * Only states with count > 0 need to be mapped before activating.
   *
   * GET /api/v{version}/Workflow/{id}/stateEntityCounts
   */
  async getStateEntityCounts(
    version: string,
    workflowId: number,
    options?: any
  ): Promise<AxiosResponse<{ data: Record<number, number> }>> {
    const axiosInstance = (this.workflowApi as any).axios;
    const basePath: string = (this.workflowApi as any).basePath;
    const headers = await this.buildHeaders();

    return axiosInstance.get(
      `${basePath}/api/v${version}/Workflow/${workflowId}/stateEntityCounts`,
      { headers, ...options }
    );
  }

  /**
   * Activates a workflow for its module.
   * Applies the state mapping to migrate existing entity records in MySQL and DynamoDB,
   * then swaps the active flag from the current active workflow to this one.
   *
   * POST /api/v{version}/Workflow/{id}/activate
   */
  async activateWorkflow(
    version: string,
    workflowId: number,
    stateMapping: StateMappingDTO[],
    options?: any
  ): Promise<AxiosResponse<{ data: boolean }>> {
    const axiosInstance = (this.workflowApi as any).axios;
    const basePath: string = (this.workflowApi as any).basePath;
    const headers = await this.buildHeaders();
    headers['Content-Type'] = 'application/json-patch+json';

    return axiosInstance.post(
      `${basePath}/api/v${version}/Workflow/${workflowId}/activate`,
      JSON.stringify({ stateMapping }),
      { headers, ...options }
    );
  }
}
